<template>
  <!-- eslint-disable vue/no-v-html -->
  <section class="section">
    <b-loading isFullPage :active="isLoading" />
    <h1 class="title has-text-centered has-text-color-7 has-text-weight-bold">
      {{ General.SEND_FEEDBACK }}
    </h1>
    <div class="title-container">
      <div class="icon-wrapper">
        <img :src="feedbackIcon" alt="" />
      </div>
      <p
        class="has-text-centered spacing-my-20 px-30 has-text-weight-medium is-size-5"
        v-html="Home.Feedback.MESSAGES.DESCRIPTION"
      />
    </div>
    <div class="form-wrapper">
      <div class="feedback-box">
        <div class="columns is-8 is-multiline is-variable">
          <b-field
            class="column is-6 mb-0"
            :label="General.TEXTS.FEEDBACK_TYPES"
            customClass="has-text-color-8"
          >
            <b-dropdown
              v-model="selectedFeedbackType"
              aria-role="menu"
              class="dropdown-field"
              expanded
            >
              <template slot="trigger">
                <b-button
                  slot="trigger"
                  class="input level minWidthType"
                  iconRight="chevron-down"
                  outlined
                >
                  <span>{{
                    selectedFeedbackType ||
                      General.PLACEHOLDER.FEEDBACK_TYPE_PLACEHOLDER
                  }}</span>
                </b-button>
              </template>

              <b-dropdown-item
                v-for="(option, index) in feedbackType"
                :key="index"
                aria-role="listitem"
                :value="option"
              >
                {{ option }}
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
          <b-field
            class="column is-6 mb-0"
            :label="General.TEXTS.FEEDBACK_REFER"
            customClass="has-text-color-8"
          >
            <b-dropdown
              v-model="selectedFeedbackRefer"
              aria-role="menu"
              class="dropdown-field"
              :maxHeight="200"
              scrollable
              expanded
            >
              <template slot="trigger">
                <b-button
                  slot="trigger"
                  class="input level minWidthRef"
                  iconRight="chevron-down"
                  outlined
                >
                  <span>{{
                    selectedFeedbackRefer ||
                      General.PLACEHOLDER.FEEDBACK_REFER_PLACEHOLDER
                  }}</span>
                </b-button>
              </template>

              <b-dropdown-item
                v-for="(option, index) in feedbackReference"
                :key="index"
                aria-role="listitem"
                :value="option"
              >
                {{ option }}
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
          <b-field
            class="column is-12 mb-0"
            :label="General.DESCRIPTION"
            customClass="has-text-color-8"
          >
            <b-input
              v-model="description"
              type="textarea"
              :placeholder="
                General.PLACEHOLDER.FEEDBACK_DESCRIPTION_PLACEHOLDER
              "
            ></b-input>
          </b-field>
          <b-field class="column is-12 mb-0" customClass="has-text-color-8">
            <template slot="label">
              <div class="is-flex is-align-items-center">
                <span>{{ General.URL }}</span>
                <span class="optional-label has-text-weight-bold ml-5">
                  {{ General.OPTIONAL }}
                </span>
              </div>
            </template>
            <b-input v-model="url" />
          </b-field>
          <b-field class="file is-primary column mb-0">
            <div class="is-flex is-flex-direction-column">
              <b-upload
                :value="files"
                class="file-label spacing-mb-5"
                multiple
                @input="addFile"
              >
                <span class="file-cta">
                  <b-icon class="file-icon" icon="upload" />
                  <span class="file-label">{{ General.ATTACH_FILE }}</span>
                </span>
              </b-upload>
              <span class="is-size-6 is-italic has-text-color-8"
                >{{ General.PLACEHOLDER.DESCRIPTION_ATTACH_FILE }}.</span
              >
            </div>
          </b-field>
          <div class="tags column">
            <span
              v-for="(file, index) in files"
              :key="index"
              class="tag is-info spacing-mx-5"
            >
              {{ file.name }}
              <button
                class="delete is-small"
                type="button"
                @click="deleteFile(index)"
              ></button>
            </span>
          </div>
        </div>
      </div>
      <div class="mb-20">
        <b-checkbox
          v-model="checkboxEmail"
          :type="isContrast ? 'is-white' : 'is-primary'"
          class="has-text-color-7"
          >{{ General.PLACEHOLDER.RECEIVE_OPINION_EMAIL }}</b-checkbox
        >
      </div>

      <div class="buttons spacing-pb-10">
        <b-button
          :type="isContrast ? 'is-white' : 'is-primary'"
          @click="confirmAction"
        >
          {{ General.SUBMIT.toUpperCase() }}
        </b-button>
        <b-button
          :type="isContrast ? 'is-white' : 'is-primary'"
          class="is-outlined"
          @click="goToPanel()"
        >
          {{ General.CANCEL.toUpperCase() }}
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { General, Home } from "@/utils/constants";
import feedbackIcon from "@/assets/svg/feedback_white.svg";

export default {
  name: "FeedbackPage",

  data() {
    return {
      General,
      Home,
      feedbackIcon,
      isLoading: false,
      selectedFeedbackType: "",
      selectedFeedbackRefer: "",
      feedbackType: Object.values(Home.Feedback.TYPES),
      feedbackReference: Object.values(Home.Feedback.REFERENCES),
      description: "",
      url: "",
      files: [],
      checkboxEmail: false
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    }),

    sizeTotal() {
      return this.files.reduce((prev, actual) => prev + actual.size, 0);
    }
  },

  methods: {
    ...mapActions({
      sendFeedback: "sendFeedback",
      sendFeedbackFile: "sendFeedbackFile",
      sendFeedbackMail: "sendFeedbackMail"
    }),

    async sendFeedbackAction() {
      this.isLoading = true;

      const feedback = await this.sendFeedback({
        type: this.selectedFeedbackType.toUpperCase(),
        area: this.selectedFeedbackRefer.toUpperCase(),
        description: this.description,
        url: this.url
      });
      if (feedback.id) {
        for await (const file of this.files) {
          const result = await this.sendFeedbackFile({
            feedback: feedback.id,
            file
          });
          if (!result) {
            this.isLoading = false;
            return false;
          }
        }

        const result = await this.sendFeedbackMail({
          feedback_id: feedback.id,
          send_me: this.checkboxEmail
        });

        result && this.goToPanel();
      }
      this.isLoading = false;
    },

    async confirmAction() {
      const fieldsRequired = [];
      !this.selectedFeedbackType &&
        fieldsRequired.push(this.General.TEXTS.FEEDBACK_TYPES.toLowerCase());
      !this.selectedFeedbackRefer &&
        fieldsRequired.push(this.General.TEXTS.FEEDBACK_REFER.toLowerCase());
      !this.description &&
        fieldsRequired.push(this.General.DESCRIPTION.toLowerCase());
      if (this.sizeTotal >= 2e6) {
        this.snackToast.open({
          message: this.General.MESSAGES.ALERT_FILES_MAX_SIZE.replace(
            "(fileSize)",
            "2mb"
          ),
          type: "is-danger",
          duration: 8000
        });
      } else if (fieldsRequired.length) {
        const message =
          fieldsRequired.length > 1
            ? this.General.MESSAGES.ALERT_REQUIRED_FIELD_PLURAL.replace(
                "(field)",
                fieldsRequired.join(", ")
              )
            : this.General.MESSAGES.ALERT_REQUIRED_FIELD.replace(
                "(field)",
                fieldsRequired[0]
              );
        this.snackToast.open({
          message,
          type: "is-danger",
          duration: 8000
        });
      } else await this.sendFeedbackAction();
    },

    addFile(value) {
      this.files = value.filter(
        file =>
          file.type.match(/image\/(png|jpg|jpeg)|application\/pdf/) &&
          file.size < 1000000
      );

      const lastValue = value[value.length - 1];
      let message = Home.Feedback.MESSAGES.FILE_ATTACHED;
      let type = "is-success";

      if (lastValue.size >= 1000000) {
        message = Home.Feedback.MESSAGES.FILE_IS_LARGER_THAN + " 1mb";
        type = "is-danger";
      }

      if (!lastValue.type.match(/image\/(png|jpg|jpeg)|application\/pdf/)) {
        message = Home.Feedback.MESSAGES.FILE_NOT_IS_ACCEPTED_TYPE;
        type = "is-danger";
      }

      this.snackToast.open({
        message,
        type,
        duration: 8000
      });
    },

    deleteFile(index) {
      this.files.splice(index, 1);
    },

    goToPanel() {
      this.$router.replace("/app");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.section {
  background-color: $color-1;
  padding: 20px 1.5rem 0 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  .form-wrapper {
    width: 65%;
    min-width: 500px;
    @media screen and (max-width: $tablet) {
      width: auto;
      min-width: auto;
    }
  }
}

.optional-label {
  font-size: 10px;
  font-weight: 300;
  color: $color-13;
}

.file-cta {
  background-color: transparent !important;
  border-color: $color-12 !important;
  color: $color-12 !important;

  &:hover {
    background-color: $color-12 !important;
    color: $color-1 !important;
  }
}

.title-container {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon-wrapper {
    display: flex;
    justify-content: center;
    width: 90px;
    img {
      width: 100%;
    }
  }
}

.feedback-box {
  border: 1px solid $border-color;
  border-radius: 5px;
  padding: 30px 40px;
  margin-bottom: 10px;
}
</style>
